"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useIgnoreThirdPartyPasswordManager;
var _react = require("react");
function useIgnoreThirdPartyPasswordManager(ignore) {
  var elementAttribute = (0, _react.useMemo)(function () {
    return ignore ? {
      'data-1p-ignore': true,
      'data-lpignore': true
    } : undefined;
  }, [ignore]);
  return elementAttribute;
}